import { useCallback } from 'react';
import { useParams } from 'react-router';
import type { MultiLang } from '../config';
import Functions from '../functions';
import DatabaseListItem from './lib/DatabaseListItem';
import ItemUtil, { type SearchCallbackFunc, type SortCondition } from './lib/ItemUtil';

interface Props {
    lang: MultiLang;
}

const DatabaseSearchByItemType = (props: Props) => {
    const { lang } = props;
    const params = useParams<{ itemType?: string; subItemType?: string }>();
    const itemType = params.itemType ?? '';
    const subItemType = params.subItemType ?? '';

    const searchFunc = useCallback(
        (condition: SortCondition, func: SearchCallbackFunc) => {
            if (itemType === '') {
                func({ total: 0, data: [] });
            } else {
                ItemUtil.getListByItemType(itemType, subItemType, condition, func);
            }
        },
        [itemType, subItemType]
    );

    let baseUrl = ItemUtil.getItemTypeSearchUrl(itemType);
    if (subItemType !== '') {
        baseUrl += `/${subItemType}`;
    }
    return (
        <div className="list">
            <h3>{Functions.mlang('[en]Listing item[/en][ja]アイテム一覧[/ja]', lang)}</h3>
            <DatabaseListItem lang={lang} url={baseUrl} search={searchFunc} />
        </div>
    );
};

export default DatabaseSearchByItemType;
